import * as Actions from './ListUserReviewsActionTypes';

const initialState = {
  reviews: {
    data: {
      reviews: [],
      totalElements: 0,
      totalPages: 0,
      currentPage: 1,
      pageSize: 10
    },
    loading: false,
    error: {
      status: false,
      message: ''
    }
  },
  reviewStatusUpdate: {
    loading: false,
    error: {
      status: false,
      message: ''
    },
    success: false
  }
};

export const userReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.FETCH_REVIEWS:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          loading: true,
          error: {
            status: false,
            message: ''
          }
        }
      };

    case Actions.FETCH_REVIEWS_SUCCESS:
      return {
        ...state,
        reviews: {
          data: action.payload,
          loading: false,
          error: {
            status: false,
            message: ''
          }
        }
      };

    case Actions.FETCH_REVIEWS_FAILS:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          loading: false,
          error: {
            status: true,
            message: action.payload?.message || 'Failed to fetch reviews'
          }
        }
      };

    case Actions.UPDATE_USER_REVIEW_STATUS:
      return {
        ...state,
        reviewStatusUpdate: {
          loading: true,
          error: {
            status: false,
            message: ''
          },
          success: false
        }
      };

    case Actions.UPDATE_USER_REVIEW_STATUS_SUCCESS:
      return {
        ...state,
        reviewStatusUpdate: {
          loading: false,
          error: {
            status: false,
            message: ''
          },
          success: true
        }
      };

    case Actions.UPDATE_USER_REVIEW_STATUS_FAILS:
      return {
        ...state,
        reviewStatusUpdate: {
          loading: false,
          error: {
            status: true,
            message: action.payload?.message || 'Failed to update review status'
          },
          success: false
        }
      };

    default:
      return state;
  }
};

